<ng-content></ng-content>


// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/chips/chips-list-notResponsive/chips-list-notResponsive.component.html